"use strict";

var _interopRequireDefault = require("/data/www/prod-cn-snote-cms/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelJdOrder = cancelJdOrder;
exports.getJdStockList = getJdStockList;
exports.pushJd = pushJd;
exports.queryJdInStock = queryJdInStock;
exports.updateJdCalculateActualStock = updateJdCalculateActualStock;
var _request = _interopRequireDefault(require("@/utils/request"));
//推送至京东仓
function pushJd(data) {
  return (0, _request.default)({
    url: 'order/push/order/by/jd',
    method: 'post',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data,
    timeout: 1800000
  });
}

//取消订单
function cancelJdOrder(data) {
  return (0, _request.default)({
    url: 'order/cancel/order/by/jd',
    method: 'post',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data,
    timeout: 1800000
  });
}

//查询京东仓库存列表
function getJdStockList(data) {
  return (0, _request.default)({
    url: 'order/stock/jd/sku/list',
    method: 'post',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data,
    timeout: 1800000
  });
}
function queryJdInStock() {
  return (0, _request.default)({
    url: 'order/query/jd/in/stock',
    method: 'get',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    timeout: 1800000
  });
}
function updateJdCalculateActualStock() {
  return (0, _request.default)({
    url: 'order/jd/stock/calculate/actual',
    method: 'get',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    timeout: 1800000
  });
}